import { Component } from '@angular/core';

@Component({
    selector: 'ddv-unsubscribed-widget-icon',
    templateUrl: './unsubscribed-widget-icon.component.html',
    styleUrls: ['./unsubscribed-widget-icon.component.scss'],
})
export class UnsubscribedWidgetIconComponent {}
